import { Article } from "./article";

export enum ArticleAction {
    SET_ARTICLES = "[ArticleAction] SET_ARTICLES",
}

interface SetArticles {
    type: ArticleAction.SET_ARTICLES;
    articles: Article[];
}

export type ArticleActionTypes = SetArticles;
